<template>
	<div id='mobile-catalog'>

		<v-app-bar
			color='white'
			class='mobile-filter-bar'
			elevate-on-scroll
			fixed
			height='64px'
		>
			<v-row
				align='center'
				:class='$vuetify.breakpoint.smAndUp ? "px-6" : ""'
				justify='space-between'
				no-gutters
				style='width: 100%; max-width: 100%; padding-top: 7px'
			>

				<v-col style='position: relative; width: 1%'>

					<filter-chips />

				</v-col>

				<v-col class='flex-grow-0'>
					<v-btn
						class='px-3 mt-3'
						color='accent'
						depressed
						style='height: 40px; border-radius: 2px; '
						@click='mobileDrawer = true'
					>
						Filtern
						<v-icon class='ml-2' dense>
							fal fa-filter
						</v-icon>
					</v-btn>
				</v-col>

			</v-row>
		</v-app-bar>

		<mobile-drawer v-model='mobileDrawer' />

		<v-row
			align='center'
			class='mt-md-13'
			:class='$vuetify.breakpoint.smAndUp ? "px-12 pt-6" : "pt-1 px-5"'
			no-gutters
		>
			<v-col cols='12'>
				<v-row>
					<v-col>
						<catalog-banner-carousel />
					</v-col>
				</v-row>

				<v-row
					align='center'
					no-gutters
					justify='space-between'
				>

					<v-col
						class='font-weight-bold'
						cols='12'
						sm='3'
					>
						<span v-if="$store.pagination.total">
							<span class='accent--text'>{{ $store.pagination.total }} Fahrzeuge</span> 
							verfügbar
						</span> 
					</v-col>

					<v-col
						class='flex-grow-0'
						cols='6'
						sm='3'
					>
						<search-order-dialog :chips='chips' />
					</v-col>

					<v-col
						class='flex-grow-0 text-right'
						cols='6'
						sm='3'
						order='2'
					>
						<select-component
							v-model='$store.sortBy'
							:label-only='$vuetify.breakpoint.mdAndDown'
							:options='$store.sortByItems'
							label='Sortierung'
							title='Sortieren nach:'
							width='174px'
						/>
					</v-col>

					<v-col v-if='isTablet' class='d-inline-flex flex-nowrap flex-grow-0  pl-3' order='4'>
						<div style='font-size: 13px' class='font-weight-bold'>
							Ansicht:
						</div>
						<v-icon
							class='clickable-icon ml-3'
							size='16'
							:color='color.galleryColor'
							@click='toggleGallery'
						>
							fa fa-th
						</v-icon>
						<v-icon
							class='ml-2 clickable-icon'
							size='16'
							:color='color.listColor'
							@click='toggleList'
						>
							far fa-list
						</v-icon>
					</v-col>
				</v-row>
			</v-col>

			<v-col class='pb-3 pt-0 mt-n1' cols='12'>
				<vehicles-list :is-list='isList || isPhone' />
			</v-col>

		</v-row>
	</div>
</template>

<script>
import VehiclesList from '@/components/VehiclesList'
import MobileDrawer from '@/components/MobileDrawer'
import SelectComponent from '@/components/SelectComponent'
import FilterChips from './FilterChips'
import CatalogBannerCarousel from './KatalogBanner/CatalogBannerCarousel';
import SearchOrderDialog from '@/components/SearchOrderDialog'

export default {
	name: 'CatalogMobile',
	components: {
    CatalogBannerCarousel,
    FilterChips,
    SelectComponent,
    MobileDrawer,
    VehiclesList,
    SearchOrderDialog
  },

	data: () => {
		return {
			mobileDrawer: false,
      isList: true,
      chips: []
    }
	},
  computed: {
    color() {
      if (this.isList) {
        return {
          galleryColor: 'grey',
          listColor: 'black'
        }
      } else {
        return {
          galleryColor: 'black',
          listColor: 'grey'
        }
      }
    },
	  isTablet(){
	    return this.$vuetify.breakpoint.name === 'sm' || this.$vuetify.breakpoint.name === 'md'
    },
    isPhone(){
      return this.$vuetify.breakpoint.name === 'xs'
    }
  },
  mounted() {
    this.$bus.$on('chipsChange', (chips) => {
      this.$nextTick(function () {
        this.chips = chips
        this.$forceUpdate()
      })
    });
  },
  methods: {
    toggleGallery() {
      this.isList = false
    },
    toggleList(){
      this.isList = true
    }
  }
}
</script>
